/** Formato de ARCA del RENSPA en la CPE: `nn.nnn.n.nnnnn/nn` (13 dígitos; error 2153 si no se respeta). */
const RENSPA_PATTERN = /^\d{2}\.\d{3}\.\d\.\d{5}\/\d{2}$/;

/** Quita todos los espacios y, si quedan exactamente 13 dígitos, les aplica el formato de ARCA. Sin valor devuelve `''`. No valida. */
export function normalizeRenspa(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s/g, '').replace(/^(\d{2})(\d{3})(\d)(\d{5})(\d{2})$/, '$1.$2.$3.$4/$5');
}

/** `true` si el RENSPA respeta el formato de ARCA. */
export function isValidRenspa(value: string): boolean {
  return RENSPA_PATTERN.test(value);
}
